<template>
  <div
    :disabled="disabled"
    :class="[
      {'rotate-animation': rotate && animationStatus},
      {'icon-button-container--disabled': disabled},
      {'icon-button-container--shadow': shadow}
    ]"
    :style="iconButtonStyle"
    class="icon-button-container"
    @click="handleClick"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <i
      :class="[`icon-${icon}`]"
      :style="colorHover && hover ? { color: colorHover } : {color: color}"
      class="icon icon-button"
    />
    <div
      :class="{'ripple--hover': hover && rippleColor}"
      :style="{backgroundColor: rippleColor, borderRadius }"
      class="ripple"
    />
    <input
      v-if="upload"
      v-show="false"
      ref="uploadInput"
      :accept="accept"
      :multiple="multipleUpload"
      type="file"
      name="uploadInput"
      @input="handleUpload"
      @click="$refs.uploadInput.value = null"
    >
  </div>
</template>

<script>

export default {
  name: 'IconButton',
  props: {
    disabled: { type: Boolean, default: false },
    rotate: { type: Boolean, default: false },
    icon: { type: String, required: true },
    color: { type: String, default: '' },
    colorHover: { type: String, default: '' },
    background: { type: String, default: '#EAEDF0' },
    backgroundHover: { type: String, default: '' },
    rippleColor: { type: String, default: '' },
    size: { type: Number, default: 20 },
    padding: { type: Number, default: 10 },
    upload: { type: Boolean, default: false },
    accept: { type: String, default: '' },
    multipleUpload: { type: Boolean, default: false },
    shadow: { type: Boolean, default: false },
    borderRadius: { type: String, default: '50%' },
    border: { type: String, default: '' },
  },
  emits: ['click', 'upload'],
  data() {
    return {
      animationStatus: false,
      hover: false,
    };
  },
  computed: {
    iconButtonStyle() {
      return Object.assign(
        {
          fontSize: `${this.size}px`,
          height: `${this.size + (this.padding * 2)}px`,
          width: `${this.size + (this.padding * 2)}px`,
          borderRadius: this.borderRadius,
        },
        this.background && { backgroundColor: this.background },
        this.backgroundHover && this.hover && { backgroundColor: this.backgroundHover },
        this.border && { border: this.border },
      );
    },
  },
  methods: {
    handleClick(evt) {
      if (!this.disabled) {
        this.animationStatus = true;
        setTimeout(() => {
          this.animationStatus = false;
        }, 900);
        if (this.upload) {
          this.$refs.uploadInput.click();
        } else {
          this.$emit('click', evt);
        }
      }
    },
    handleUpload(evt) {
      if (evt.target.files.length) this.$emit('upload', Array.from(evt.target.files));
    },
  },
};
</script>

<style lang="scss">

.icon-button-container{
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .ripple {
    position: absolute;
    z-index: 1;
    height: 100%;
    width: 100%;
    transform: scale(0);
    transition: transform 0.2s ease-in-out;
    &--hover {
      transform: scale(1);
    }
  }

  &--disabled {
    cursor: not-allowed;
  }

  &--shadow {
    box-shadow: 0 2px 10px 0 rgba(23,132,251,0.30);
  }

  .icon-button {
    position: absolute;
    z-index: 2;
  }

  &.icon-button--primary .icon-button {
    color: $blue-east-bay;
  }


  &.rotate-animation .icon-button{
    animation-name: rotation;
    animation-duration: 0.8s;
    animation-timing-function: linear;
    animation-fill-mode: both;
  }
  @keyframes rotation{
    0%{
      transform: rotate(0deg);
    }
    33% {
      transform: rotate(100deg);
    }
    66%{
      transform: rotate(200deg);
    }
    100%{
      transform: rotate(360deg);
    }
  }

}


</style>

